import angular from 'angular';
import { ModalsReminder } from '@alquilatucancha/backoffice-integration';

const moduleName = 'atc-reminder-modals';

angular.module(moduleName, []).directive('modalsReminder', [
    'Backoffice',
    (Backoffice) => ({
        restrict: 'A',
        link: (_scope, el) => {
            Backoffice.renderComponent(el[0], ModalsReminder, undefined, {
                silent: true,
            });

            // El <div modals-reminder> vive ahora en app.html (shell post-login),
            // que Angular destruye en cada logout. Sin este unmount, el root de
            // React y su listener global de 'hashchange' quedan huérfanos y se
            // acumulan en cada ciclo logout/login.
            _scope.$on('$destroy', () => {
                Backoffice.unmountComponent?.(el[0]);
            });
        },
    }),
]);

export default moduleName;
